import { useEffect, useState } from 'react';

import { IUserData } from 'components/ChangesVersioning/HistoryItem';
import { VaultService } from 'utils/storage';

const vaultService = new VaultService();

const parseUserFromStorage = (): IUserData | null => {
	const userStr = localStorage.getItem('user');
	if (!userStr) return null;
	try {
		return JSON.parse(userStr) as IUserData;
	} catch {
		return null;
	}
};

export const useGetUser = () => {
	const [user, setUser] = useState<IUserData | null>(parseUserFromStorage());
	const [token, setToken] = useState<string | null>(
		localStorage.getItem('user') ? vaultService.getItem('token') : null
	);

	useEffect(() => {
		const handleStorageChange = () => {
			const updatedUserValue = parseUserFromStorage();
			const updatedTokenValue = vaultService.getItem('token');

			if (updatedUserValue !== user) {
				setUser(updatedUserValue);
			}

			if (updatedTokenValue !== token) {
				setToken(updatedTokenValue);
			}
		};

		window.addEventListener('storage', handleStorageChange);

		return () => {
			window.removeEventListener('storage', handleStorageChange);
		};
	}, [user, token]);

	return {
		user,
		token,
		setUser,
	};
};
